<template>
    <div class="bg_wrap">
        <div class="yazam_wrap" :class="{open: displayYazam, close: closeYazam}" v-click-away="close_yazam" >
            <a class="close" @click="close_yazam"  :class="{active: displayYazam}">
                <div class="icon close_icon"></div>
            </a>
            <div class="yazam_wrap_scroll">
                <div class="yazam_card">
                    <div class="info">
                        <div class="titles">
                            <div class="first_titles">
                                <div class="title" v-text="yazam_data.data.company_name"></div>
                                <div  v-text="yazam_data.display_name"></div>
                                <a target="_blank" :href="yazam_data.data.link_company_site" v-text="yazam_data.data.link_company_site"></a>
                            </div>
                            <div class="num_projects">
                                <div class="icon_wrap">
                                    <div class="icon building_white_icon"></div>
                                </div>
                                <div> השתתף ב {{yazam_data.projects.length + yazam_data.projects_urban.length}} מכרזים</div>
                            </div>
                        </div>
                        <div class="contact">
                            <div class="detail">
                                <div class="icon_wrap">
                                    <div class="icon location_icon"></div>
                                </div>
                                <div v-text="yazam_data.data.company_address"></div>
                            </div>
                            <div class="detail">
                                <div class="icon_wrap">
                                    <div class="icon phone_icon"></div>
                                </div>
                                <div v-text="yazam_data.data.phone_company_contact" ></div>
                            </div>
                            <div class="detail">
                                <div class="icon_wrap">
                                    <div class="icon contact_icon"></div>
                                </div>
                                <div v-text="yazam_data.data.phone_company_contact + ' | ' + yazam_data.data.phone_company_contact"></div>
                            </div>
                            <div class="detail">
                                <div class="icon_wrap">
                                    <div class="icon email_icon"></div>
                                </div>
                                <div v-text="yazam_data.username"></div>
                            </div>
                        </div>
                    </div>
                    <div class="yazam_img" :style="bg(yazam_data.data.company_logo)"></div>
                </div>
                <div class="yazam_content">
                    <ul>
                        <li v-for="tab in tabs" :key="tab.name" :class="{active: currTab==tab.name}">
                            <div @click="currTab=tab.name" v-text="tab.title"></div>
                        </li>
                    </ul>
                    <div class="tab" v-if="currTab=='about'">
                        <div class="about_text" v-if="yazam_data.data.about_company" v-text="yazam_data.data.about_company"></div>
                        <div class="work_class">
                            <div class="working_areas" v-if="yazam_data.data.activity_areas">
                                <div class="title">אזורי פעילות</div>
                                <div class="areas">
                                    <div v-for="work_area in yazam_data.data.activity_areas" :key="work_area">
                                        <div class="work_area" v-text="work_area.name"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="classification" v-if="yazam_data.data.classification_type_text">
                                <div class="title">סיווג קבלני</div>
                                <div v-text="yazam_data.data.classification_type_text"></div>
                            </div>
                        </div>
                        <div class="links">
                            <div class="title">קישורים נוספים</div>
                            <div class="actions">
                                <a target="_blank" v-if="yazam_data.data.company_presentation" :href="yazam_data.data.company_presentation" class="btn2 text_s"><div class="icon download_icon"></div>הורדת מצגת מהחברה</a>
                                <a target="_blank" v-if="yazam_data.data.promotional_video_link" :href="yazam_data.data.promotional_video_link" class="btn2 text_s"><div class="icon play_icon"></div>צפייה בסרטון תדמית</a>
                            </div>
                            <div class="soci">
                                <div v-if="yazam_data.data.linkedin_link">
                                    <a target="_blank" :href="yazam_data.data.linkedin_link" class="btn2 text_s"><div class="icon linkedin_icon"></div></a>
                                </div>
                                <div v-if="yazam_data.data.facebook_link">
                                    <a target="_blank" :href="yazam_data.data.facebook_link" class="btn2 text_s"><div class="icon facebook_icon"></div></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab" v-if="currTab=='details'">
                        <div class="working_with">
                            <div class="title">עובדים עם הגופים הבאים</div>
                            <div class="entity_wrap">
                                <div class="entity" v-if="yazam_data.data.banks_financial_support">
                                    <h4>בנקים</h4>
                                    <div class="spec_entity_wrap">
                                        <div v-for="spec_entity in yazam_data.data.banks_financial_support" :key="spec_entity">
                                            <div class="spec_entity" v-text="spec_entity.name"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="entity" v-if="yazam_data.data.insurance_companies">
                                    <h4>חברות ביטוח</h4>
                                    <div class="spec_entity_wrap">
                                        <div v-for="spec_entity in yazam_data.data.insurance_companies" :key="spec_entity">
                                            <div class="spec_entity" v-text="spec_entity.name"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="entity" v-if="yazam_data.data.financing_companies">
                                    <h4>חברות מימון חוץ בנקאיות</h4>
                                    <div class="spec_entity_wrap">
                                        <div v-for="spec_entity in yazam_data.data.financing_companies" :key="spec_entity">
                                            <div class="spec_entity" v-text="spec_entity.name"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="prof_rated">
                            <div class="title">דירוגים מקצועיים</div>
                            <div class="rated">
                                <template  v-for="(rated,i) in rates" :key="i">
                                    <div class="rated_comp" :class="{not_active: !rated.active, checked: rated.checked }"  @mouseover="rated.hover=true" @mouseleave="rated.hover=false">
                                        <div :class="'pic '+rated.class" ></div>
                                        <a target="_blank" class="link" :href="rated.link" v-if="rated.hover && rated.active && rated.link != ''"><div class="icon watch_icon"></div>לצפייה</a>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="people" v-if="yazam_data.staff">
                            <div class="title">בעלי תפקידים בהתחדשות עירונית</div>
                            <div class="persons">
                                <div v-for="(person,i) in yazam_data.staff" :key="i" class="person">
                                    <div class="person_img" :class="{nopic: person.pic_parsed==''}" :style="person.pic_parsed != '' ? bg(person.pic_parsed) : ''"></div>
                                    <div class="title" v-text="person.name"></div>
                                    <div v-text="person.title"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab" v-if="currTab=='more_details'">
                        <div class="card_b">
                            <div class="head only" >
                                <div class="sec" v-if="yazam_data.projects">
                                    <div class="title">התחדשות בניינית</div>
                                    <div>{{yazam_data.projects.length + ' פרוייקטים'}}</div>
                                </div>
                                <div class="sec" v-if="yazam_data.projects_urban">
                                    <div class="title">התחדשות מתחמית</div>
                                    <div>{{yazam_data.projects_urban.length + ' פרוייקטים'}}</div>
                                </div>
                                <div class="sec">
                                    <div class="title">סה"כ</div>
                                    <div>{{(yazam_data.projects.length + yazam_data.projects_urban.length) + ' פרוייקטים'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card_b active" v-if="yazam_data.projects.length > 0">
                            <div class="head">
                                <div  class="title">התחדשות בניינית</div>
                            </div>
                            <div class="content" >
                                <div v-for="(building, i) in yazam_data.projects" :key="i">
                                    <div class="clause">
                                        <div class="title2">#{{i+1}}</div>
                                        <div>
                                            <div class="title2">כתובת</div>
                                            <div v-text="building.address"></div>
                                        </div>
                                        <div>
                                            <div class="title2">כמות יחידות</div>
                                            <div>{{building.num_before}} לפני {{building.num_after}} אחרי</div>
                                        </div>
                                        <div>
                                            <div class="title2">סטטוס</div>
                                            <div v-text="building.status"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="card_b active" v-if="yazam_data.projects_urban">
                            <div class="head">
                                <div  class="title">התחדשות מתחמית</div>
                            </div>
                           <div class="content">
                                <div v-for="(building, i) in yazam_data.projects_urban" :key="i">
                                    <div class="clause">
                                        <div class="title2">#{{i+1}}</div>
                                        <div>
                                            <div class="title2">כתובת</div>
                                            <div v-text="building.address"></div>
                                        </div>
                                        <div>
                                            <div class="title2">כמות יחידות</div>
                                            <div>{{building.num_before}} לפני {{building.num_after}} אחרי</div>
                                        </div>
                                        <div>
                                            <div class="title2">סטטוס</div>
                                            <div v-text="building.status"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <!-- <table border="1">
    <thead>
        <tr>
            <th>#</th>
            <th>כתובת</th>
            <th>כמות יחידות (לפני)</th>
            <th>כמות יחידות (אחרי)</th>
            <th>סטטוס</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="(building, i) in yazam_data.projects_urban" :key="i">
            <td>{{i+1}}</td>
            <td>{{building.address}}</td>
            <td>{{building.num_before}}</td>
            <td>{{building.num_after}}</td>
            <td>{{building.status}}</td>
        </tr>
    </tbody>
</table> -->

            <div class="prj_data_con_table">

                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th><strong>התחדשות מתחמית</strong></th>
                            <th>כתובת</th>
                            <th>כמות יחידות</th>
                            <!-- <th>כמות יחידות (אחרי)</th> -->
                            <th>סטטוס</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(building, i) in yazam_data.projects_urban" :key="i">
                            <td>#{{i+1}}</td>
                            <td>{{building.address}}</td>
                            <td >
                                <h5>כמות יחידות</h5>
                                <p><span><strong>{{ building.num_before }}</strong> לפני</span> <span><strong>{{ building.num_after }}</strong> אחרי</span></p>
                            </td>
                            <td>{{building.status}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['yazam_data'],
    data() {
        return {
            displayYazam: false,
            closeYazam: false,
            rates: [],
         
            selected_content: 0,
            currTab: "about",
            tabs: [
                {
                    name: "about",
                    title: "אודות החברה"
                },
                {
                    name: "details",
                    title: "פרטים מקצועיים"
                  
                },
                {
                    name: "more_details",
                    title: "פירוט על הפרוייקט",
                }
            ]
        }
    },
    mounted() {

        if(this.yazam_data.data.bdi_report_file) this.rates.push({class:'bdi_icon', link: this.yazam_data.data.bdi_rating_link, active: true, checked: false, hover: false});
        if(this.yazam_data.data.duns_report_file) this.rates.push({class:'duns_icon', link: this.yazam_data.data.bdi_rating_link, active: true, checked: false, hover: false});
        if(this.yazam_data.data.urban_renewal_rating_link) this.rates.push({class:'madad_icon', link: this.yazam_data.data.bdi_rating_link, active: true, checked: false, hover: false});

        setTimeout(() => {
            this.displayYazam = true;
        }, 100)
    },
    methods: {
        close_yazam() {
            this.closeYazam = true;
            setTimeout(() => {
                this.$bus.$emit('close_yazamdata')
            }, 500)
        }
    }
};
</script>

<style lang="scss" scoped>
.prj_data_con_table { position: relative; overflow-y: auto; overflow-x: hidden; border-radius: var(--radius); border-style: hidden;box-shadow: 0 0 0 1px var(--pageBG); 
            
    table { border-collapse: collapse; border-spacing: 30px;
        
        thead { z-index: 1; background: var(--gray);position: sticky; 
top: 0px; }
        // tbody { display: block; max-height: 300px; overflow-y: auto;} 
        
        tr {
            &.active, &:hover {
                .send_invitation { opacity: 1; }
            }
            &:not(:first-child) { border-top: 1px solid var(--pageBG);
                &:hover {
                    &, & + * { border-top: 1px solid var(--light_blue); 
                        
                    }
                }
            }
            .text_icon { display: flex; align-items: center; gap: 7px;
                .icon { fill: var(--light_blue);}
            }
            // &:hover {
            //     &, + { border-bottom: 1px solid #333; }
            // }
            
            th {
                &:first-child { padding-inline: var(--gap_xbig) 0;}
                // &:last-child { padding-inline: 0 var(--gap_xbig);}
                // & > * {display: inline-block !important;}
                .dunsloo_icon { width: 46px; height: 56px; }
                
            }
            td {padding-block: var(--gap); 
                h5 { color: var(--text_s);}
                p {
                    strong { font-weight: bold;}
                    span { 
                        &:first-child { margin-left: 6px;}
                    }
                }
                &:first-child { padding-inline: var(--gap_big) 0;}
                &.send_invitation { opacity: 0; }
                &.logo_name { 
                    .text_icon_container { display: flex; align-items: center; gap: var(--gap_mid);
                    cursor: pointer;
                        .icon_container { padding: var(--padding_small); display: flex; justify-content: center; align-items: center; width: 60px; height: 60px; border-radius: var(--radius_s);
                            .icon { width: 100%; height: 100%; background-size: contain;background-repeat: no-repeat;background-position: center; }
                        
                        }
                    }
                }
                &.file_container { min-width: 75px;
                    &:hover {
                        .icon_text_container {
                            .icon { display: none;}
                            .text { display: block;}
                        }
                    }
                    .icon_text_container { 
                        .text { cursor: pointer; display: none; color: var(--dark_blue); font-weight: bold; text-decoration: underline;}
                    }
                }
                // &:last-child { padding-inline: 0 var(--gap_big);}
                .activity_areas {display: flex; 
                    span {margin-left: 5px;}
                }
                >.btn_b { flex-direction: column;/*padding-block: 7px;*/ gap: 0px !important; width: fit-content; margin: 0 auto; transition: all ease 0.3s;
                    > span { transform: translateY(20%); opacity: 1;  max-height: 999px;}
                }
                .cencel_invitation_container {align-items: normal; display: flex; gap: 0; border: none; width: fit-content; background: #D7D6FF; border-radius: var();
                    > span { transform: translateY(-100%); opacity: 0;  max-height: 0;}
                    
                }
                .cencel_invitation { padding-block: 10px; max-height: 0; max-width: 0px; display: flex; align-items: center; gap: var(--gap_xmid);
                    &.active { max-width: 9999px; max-height: 999px;
                        > span { opacity: 1; transform: translateX(0%);}
                        .btn_b { opacity: 1; transform: translateX(0%);}
                    }
                    > span { transition: all ease 0.2s; opacity: 0; transform: translateX(100%); color: #3F3BCC; font-size: var(--h5); font-weight: normal;}
                    .btn_b { width: fit-content; opacity: 0; transition: all ease 0.2s; transform: translateX(-100%);}
                }
            }
        }
    }
}


*{color: var(--dark_blue);font-weight: 500;}
.title {color: var(--title_color);font-weight: 600;}
.title2 {color: var(--text_s);}
.bg_wrap {width: 100%;position: fixed;height: 100%;top: 0;right: 0;z-index: 999999;background: var(--darkBG);}
.icon_wrap {border: none;background-color: var(--very_light_blue);width: 32px;height: 32px;border-radius: 100%;background-size: 80%;display: flex;justify-content: center;align-items: center;}
.icon {width: 22px;height: 22px;}
.close {
    &{position: absolute;
    top: 20%;
    right: -50px;
    transform: translateX(100%);
    width: 40px;
    height: 40px;
    background: white;
    border: 1px solid var(--text_s);
    border-radius: 16px;
    display: none;
    justify-content: center;
    align-items: center;}
    &.active {display: flex;}
}
.yazam_wrap {
    &{left: 0;top: 0;z-index: 99999;
    height: 100%;min-width: 800px;
    transition: transform 0.5s ease;transform: translateX(-100%);}
    &.open {position: fixed;transform: translateX(0);width: 50%;}
    &.close{position: fixed;transform: translateX(-100%);}
    .yazam_wrap_scroll { background: white; width: 100%; height: 100%; overflow-y:scroll; padding: var(--gap_mid); display: flex;flex-direction: column;gap: var(--gap_big);}
    .yazam_content {
        &{padding: 0 0 0 var(--gap_xbig);display:flex;flex-direction: column;gap: var(--gap_big);}
        ul {
            &{display: flex; gap: var(--gap_mid); overflow: auto;border-bottom: 1px solid var(--Border-card-hover, #80A3B6);}
            li { 
                &{position: relative; flex-shrink: 0; cursor: pointer; display: flex; gap: 5px;color:var(--text_s);font-weight: 700;}
                &.active {
                    &{color:var(--title_color)}
                    &::after {content: ''; position: absolute; bottom: 0; right: 0; left: 0; background: var(--title_color); height: 4px; border-radius: 8px;}
                    span {color: var(--title_color);}
                }
                &:not(.active) {
                    div {color: var(--text_s)}
                }
                div { padding-bottom: 10px;font-size: 20px;font-family: var(--font2);}
                span {color: var(--text_s); font-size: var(--h4);}
            }
        }
        .tab {
            &{display: flex;flex-direction: column;justify-content: center;gap: var(--gap_xbig);}
            .about_text { white-space: pre-wrap; }
            .card_b {
                .head {
                    &.only{justify-content: center;}
                    .sec {display: flex;gap: var(--gap);padding:var(--gap);
                    &:nth-child(2) {border-left: 1px solid var(--pageBG);border-right: 1px solid var(--pageBG)}}
                }
                .content {padding:0 !important}
                .clause {display: flex;justify-content: space-around;padding: var(--gap_mid) var(--gap_big);align-items: center;border-bottom: 1px solid var(--pageBG);}
            }
            .work_class{
                &{display:flex;gap:var(--gap_xbig)}
                .working_areas {
                    &{display: flex;flex-direction: column;gap: var(--gap);}
                    .areas {
                        &{display: grid;grid-template-columns: repeat(3, 1fr);gap:12px;}
                        .work_area {
                            background: var(--gray);border: 1px solid var(--pageBG);display: flex;justify-content: center;align-items: center;border-radius: var(--radius_x);padding: 8px 32px;
                        }
                    }
                }
                .classification{ 
                    &{display: flex;flex-direction: column;gap: var(--gap);}
                }
            }
            .links{
                &{display: flex;flex-direction: column;gap: var(--gap);}
                .actions {display: flex;gap: var(--gap);}
                .soci {
                    &{display: flex;justify-content: flex-start;gap: var(--gap)}
                    div {width: fit-content;}
                    .btn2 {width: 42px;height: 42px;}
                }
                .btn2 {
                    &{box-shadow: var(--box-shadow);min-height: 40px;border: solid 1px var(--text_s);border-radius: 12px;display: flex;justify-content: center;align-items: center;text-align: center;font-size: var(--h5);flex-basis: 27%;gap: 4px;}
                    .icon {width: 24px;height: 24px;}
                }
            }
            .working_with {
                &{display: flex;flex-direction: column;gap: var(--gap);}
                .entity_wrap{
                     &{display: flex;flex-wrap: wrap;gap: var(--gap_mid) var(--gap_xbig);}
                    .entity {
                        display: flex;flex-direction: column;gap: var(--gap);
                        h4 { font-weight: bold;}
                        .spec_entity_wrap {
                            &{display: grid;grid-template-columns: repeat(3, 1fr);gap:12px;}
                            .spec_entity {
                                background: var(--gray);border: 1px solid var(--pageBG);display: flex;justify-content: center;align-items: center;border-radius: var(--radius_x);padding: var(--gap_small) var(--gap);
                            }
                        }
                    }
                }
            }
            .prof_rated {
                &{display: flex;flex-direction: column;gap: var(--gap_mid);}
                .rated {
                    &{display: flex;gap: var(--gap_xmid);flex-wrap: wrap;}
                    .rated_comp {
                        &{border: 1px solid var(--light_blue);width: 200px;height: 150px;box-shadow: 1px 6px 12px 0px #002D551A;border-radius: var(--radius);display: flex;justify-content: center;align-items: center;position: relative;}
                        &.not_active {
                            &{border: 1px solid var(--pageBG);box-shadow:none;}
                            .pic {opacity: 0.5;}
                        }
                        &.checked {
                            &::after {content: "";display: block;position: absolute;top: -10%;right: 6%;height: 45px;aspect-ratio: 1;background: url("../assets/verified.svg");background-size: contain;background-repeat: no-repeat;}

                        }
                        .link {
                            display: flex;justify-content: center;align-items: center;gap:5px;
                            position: absolute;bottom: 10%;right: 12px;background: var(--gray); font-weight: 700;text-decoration: underline;padding: var(--gap_small) var(--gap);border-radius: var(--radius_s);}
                        .pic {width: 110px;aspect-ratio: 1;background-size: contain;background-repeat: no-repeat;}
                    }
                }
            }
            .people {
                &{display: flex;flex-direction: column;gap:var(--gap);}
                .persons {
                    &{display: grid;grid-template-columns: repeat(4,1fr); gap: var(--gap_mid) var(--gap_xmid);}
                    .person {
                        .title{line-height: 1.4;;font-weight: 700;}
                        .person_img {
                            &{width: 100%;aspect-ratio: 1;background-size: cover;background-repeat: no-repeat}
                            &.nopic {background-image: url("../assets/no_pic.svg");}
                        }
                    }
                }
            }
        }
    }
}
</style>